var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"behavior_book_control_button",attrs:{"fab":"","small":"","text":"","absolute":"","right":"","bottom":""},on:{"click":function($event){_vm.controls = !_vm.controls}}},[_c('v-icon',[_vm._v(" mdi-wrench ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }